import { AppVersion } from "@app/core/version/domain/model/app-version";
import { Observable } from "rxjs";

export abstract class VersionRepo {
  abstract getMinimumVersion(): Observable<AppVersion>;
  abstract getAppVersion(): Observable<AppVersion>;
}
